/**
 * Description: HTTP 设置Config的方法类
 * @author: lhc
 * @date: 2022/2/7 19:19
 */
class HttpConfig {
  /**
   * Description: 有关网络请求设置的关键字
   * @author: lhc
   * @date: 2022/2/7 16:20
   */
  static  _TYPE = {
    ON_UPLOAD_PROGRESS: 'onUploadProgress',
    LOADING: 'loading',
    LOADING_TARGET: 'loadingTarget',
    TIP: 'isShowTip',
    CANCLE_KEY: 'cancleId',
    CANCLE_DEFAULT: 'cancle'
  }

  config = {
    headers: {}
  }

  static obtain() {
    return new HttpConfig()
  }

  done() {
    return this.config
  }

  /**
   * Description: 添加自定义的配置信息
   * @author: lhc
   * @date: 2022/2/7 17:38
   */
  addConfig(key, value) {
    this.config[key] = value
    return this
  }

  /**
   * Description:  添加头信息
   * @author: lhc
   * @date: 2022/2/7 16:49
   */
  addHeader(key, value) {
    this.config.headers[key] = value
    return this
  }

  /**
   * Description: 设置是否显示加载进度，默认开启
   * @author: lhc
   * @date: 2022/2/7 16:35
   */
  setLoading(flag = true) {
    return this.addConfig(HttpConfig._TYPE.LOADING, flag)
  }

  /**
   * Description: 开启加载进度
   * @author: lhc
   * @date: 2022/2/7 16:37
   */
  openLoading() {
    return this.setLoading(true)
  }

  /**
   * Description: 关闭加载进度
   * @author: lhc
   * @date: 2022/2/7 16:37
   */
  closeLoading() {
    return this.setLoading(false)
  }

  /**
   * Description: 使用设置的target,比如el-table
   * @author: lhc
   * @date: 2022/2/7 16:35
   */
  setLoadingTarget(value) {
    return this.addConfig(HttpConfig._TYPE.LOADING_TARGET, value)
  }

  /**
   * Description: 设置是否显示提示，默认开启
   * @author: lhc
   * @date: 2022/2/7 16:42
   */
  setTip(flag = true) {
    return this.addConfig(HttpConfig._TYPE.TIP, flag)
  }

  /**
   * Description:  开启提示
   * @author: lhc
   * @date: 2022/2/7 16:42
   */
  openTip() {
    return this.setTip(true)
  }

  /**
   * Description:  关闭提示
   * @author: lhc
   * @date: 2022/2/7 16:42
   */
  closeTip() {
    return this.setTip(false)
  }

  /**
   * Description:  设置网络请求id
   * @author: lhc
   * @date: 2022/2/7 16:49
   */
  setId(id) {
    return this.addConfig(HttpConfig._TYPE.CANCLE_KEY, id)
  }

  /**
   * Description: 监听网络请求进度
   * @author: lhc
   * @date: 2022/2/7 17:44
   */
  setOnUploadProgress(listener) {
    return this.addConfig(HttpConfig._TYPE.ON_UPLOAD_PROGRESS, listener)
  }

}

export default HttpConfig
